var map = {
	"./blue-dress-2.webp": 8350,
	"./blue-dress.png": 8120,
	"./blue-dress.webp": 3642,
	"./green-dress-2.webp": 8644,
	"./green-dress.png": 2474,
	"./green-dress.webp": 6000,
	"./purple-dress-2.webp": 8513,
	"./purple-dress.png": 8385,
	"./purple-dress.webp": 6533,
	"./red-dress-2.webp": 8626,
	"./red-dress.png": 4316,
	"./red-dress.webp": 9602,
	"./yellow-dress-2.webp": 8511,
	"./yellow-dress.png": 5161,
	"./yellow-dress.webp": 3459
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 345;